module.exports = __webpack_public_path__ + "img/img-master-card.9cb4e855.svg";